// 12 categorías oficiales de acuadros.co — grid 4×3 en /categorias.
// Cada una tiene foto "normal" (la obra) y foto "wall" (el cuadro en pared,
// con detalle de ambiente) para el hover/encabezado de categoría.

const u = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=75`;

export const CATEGORIES = [
  {
    slug: "mascotas",
    name: "Mascotas",
    tagline: "Retratos que capturan su carácter",
    description:
      "Retratos pictóricos de perros, gatos y compañeros de vida. El regalo que más emociona.",
    image: u("1546361897-9103555dd95c"),
    wallImage: u("1583847268964-b28dc8f51f92", 1200),
  },
  {
    slug: "abstracto",
    name: "Abstracto",
    tagline: "Color y forma para espacios con intención",
    description:
      "Composiciones geométricas y orgánicas que estructuran cualquier ambiente sin saturarlo.",
    image:
      "https://images.pexels.com/photos/545575/pexels-photo-545575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    wallImage: u("1493809842364-78817add7ffb", 1200),
  },
  {
    slug: "paisajes",
    name: "Paisajes & Naturaleza",
    tagline: "Ventanas a lugares extraordinarios",
    description:
      "Montañas, bosques y mares en alta fidelidad. Profundidad y calma para tus muros.",
    image: u("1470071459604-3b5ec3a7fe05"),
    wallImage: u("1598928506311-c55ded91a20c", 1200),
  },
  {
    slug: "minimalista",
    name: "Minimalista",
    tagline: "Menos elementos, más presencia",
    description:
      "Trazos únicos y composiciones de línea con estética escandinava para espacios contemporáneos.",
    image:
      "https://images.pexels.com/photos/8251473/pexels-photo-8251473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    wallImage: u("1586023492125-27b2c045efd7", 1200),
  },
  {
    slug: "botanico",
    name: "Botánico",
    tagline: "Verde que respira en tu pared",
    description:
      "Hojas, helechos y flora ilustrada. El equilibrio perfecto entre lo natural y lo decorativo.",
    image: u("1416339306562-f3d12fefd36f"),
    wallImage: u("1616594039964-ae9021a400a0", 1200),
  },
  {
    slug: "frases",
    name: "Frases & Tipografía",
    tagline: "Palabras que decoran y motivan",
    description:
      "Frases, letras y composiciones tipográficas para estudios, oficinas y rincones con mensaje.",
    image: u("1455390582262-044cdead277a"),
    wallImage: u("1513519245088-0e12902e5a38", 1200),
  },
  {
    slug: "ciudades",
    name: "Ciudades & Mapas",
    tagline: "Skylines y lugares con historia",
    description:
      "Ciudades icónicas, mapas y rincones urbanos. Para los que llevan un destino en el corazón.",
    image: u("1477959858617-67f85cf4f1df"),
    wallImage: u("1554995207-c18c203602cb", 1200),
  },
  {
    slug: "retratos",
    name: "Retratos & Familia",
    tagline: "Tus momentos, convertidos en arte",
    description:
      "Retratos familiares, parejas y recuerdos personalizados impresos en MDF de alta calidad.",
    image: u("1511671782779-c97d3d27a1d4"),
    wallImage: u("1505691938895-1758d7feb511", 1200),
  },
  {
    slug: "infantil",
    name: "Infantil",
    tagline: "Cuartos que inspiran a los más pequeños",
    description:
      "Ilustraciones tiernas y coloridas para habitaciones de bebés y niños.",
    image: u("1519689680058-324335c77eba"),
    wallImage: u("1567016432779-094069958ea5", 1200),
  },
  {
    slug: "religioso",
    name: "Religioso & Espiritual",
    tagline: "Fe y serenidad en cada detalle",
    description:
      "Arte sacro, versículos y piezas espirituales que acompañan y protegen tu hogar.",
    image: u("1438232992991-995b7058bbb3"),
    wallImage: u("1615529182904-14819c35db37", 1200),
  },
  {
    slug: "musica-cine",
    name: "Música & Cine",
    tagline: "Cultura pop para tus muros",
    description:
      "Pósters, instrumentos y escenas icónicas para fanáticos del buen sonido y la pantalla.",
    image: u("1511379938547-c1f69419868d"),
    wallImage: u("1524758631624-e2822e304c36", 1200),
  },
  {
    slug: "deportes",
    name: "Deportes",
    tagline: "Pasión que se cuelga en la pared",
    description:
      "Momentos, canchas y leyendas deportivas. Energía para gimnasios, cuartos y estudios.",
    image: u("1461896836934-ffe607ba8211"),
    wallImage: u("1601758124510-52d02ddb7cbd", 1200),
  },
];

export const getCategory = (slug) =>
  CATEGORIES.find((c) => c.slug === slug) || null;
